export const bannedWords = {
  sildenafil: true,
  tadalafil: true,
  vardenafi: true,
  sulfoaildenafil: true,
  desmethyl: true,
  carbodenafil: true,
  libido: true,
  sexual: true,
  enhancement: true,
  sex: true,
  drive: true,
  performance: true,
  enhance: true,
  male: true,
  female: true,
  climax: true,
  vascularity: true,
  vitality: true,
  level: true,
  estrogen: true,
  testosterone: true,
  sibutramine: true,
  desmethylsibutramine: true,
  phenolphthalein: true,
  fluoxetine: true,
  fat: true,
  burner: true,
  burn: true,
  "fat burner": true,
  weight: true,
  "weight loss": true,
  "weight management": true,
  nighttime: true,
  increase: true,
  diet: true,
  lose: true,
  "lose weight": true,
  loss: true,
  belly: true,
  "belly fat": true,
  slim: true,
  appetite: true,
  "appetite control": true,
  calories: true,
  "all natural": true,
  anti: true,
  antibacterial: true,
  antifungal: true,
  antimicrobial: true,
  antiviral: true,
  bacteria: true,
  bacterial: true,
  candida: true,
  capsule: true,
  capsules: true,
  chemicals: true,
  defoliant: true,
  desiccant: true,
  destroy: true,
  destroying: true,
  disinfect: true,
  eliminate: true,
  eliminator: true,
  five: true,
  fluke: true,
  four: true,
  fungal: true,
  fungi: true,
  fungicide: true,
  fungus: true,
  germ: true,
  gummies: true,
  gummy: true,
  harmless: true,
  herbicide: true,
  infection: true,
  injurious: true,
  insect: true,
  insecticide: true,
  insecticides: true,
  instrument: true,
  kill: true,
  medical: true,
  methionine: true,
  methylsulfonylmethane: true,
  microbial: true,
  microorganism: true,
  mildew: true,
  mite: true,
  mitigate: true,
  mold: true,
  molds: true,
  ozone: true,
  pathological: true,
  pest: true,
  pesticidal: true,
  pesticide: true,
  pesticides: true,
  pill: true,
  pills: true,
  poisonous: true,
  pollen: true,
  pollutant: true,
  pollution: true,
  prevent: true,
  preventing: true,
  quercetin: true,
  regulator: true,
  repel: true,
  repellant: true,
  repelling: true,
  rodent: true,
  safe: true,
  safety: true,
  sanitize: true,
  sanitizer: true,
  softgel: true,
  softgels: true,
  spore: true,
  sterilize: true,
  tablet: true,
  tablets: true,
  three: true,
  thymoquinone: true,
  toxic: true,
  trap: true,
  viral: true,
  virus: true,
  viruses: true,
  weeds: true,
  pro: true,
  acetyl: true,
  acid: true,
  acute: true,
  adaptogen: true,
  adaptogenic: true,
  addiction: true,
  ADHD: true,
  adult: true,
  aid: true,
  aids: true,
  allergenic: true,
  alleviate: true,
  amanita: true,
  amazon: true,
  "anti-inflammation": true,
  "anti-inflammatory": true,
  antibodies: true,
  antigens: true,
  antioxidant: true,
  anxiety: true,
  "appetite suppressant": true,
  approved: true,
  argyreia: true,
  "arterial quality": true,
  arteries: true,
  artery: true,
  "artery strength": true,
  assurance: true,
  asthma: true,
  attack: true,
  "baby hawaiian woodrose": true,
  "baby woodrose": true,
  bald: true,
  baldness: true,
  bidhara: true,
  "birth control": true,
  blockage: true,
  blood: true,
  "blood cell": true,
  "blood cell count": true,
  "blood flow": true,
  "blood pressure": true,
  "blood sugar": true,
  "blood sugar metabolism": true,
  boost: true,
  booster: true,
  boosting: true,
  burning: true,
  cancer: true,
  cardiovascular: true,
  cbd: true,
  "cell count": true,
  cholesterol: true,
  chronic: true,
  circulation: true,
  circulatory: true,
  claim: true,
  claims: true,
  clogged: true,
  coca: true,
  "congestive ": true,
  control: true,
  controlled: true,
  convolvulus: true,
  correct: true,
  cortisol: true,
  cravings: true,
  curbs: true,
  cure: true,
  curing: true,
  cysteine: true,
  dagga: true,
  dandruff: true,
  datura: true,
  defect: true,
  deficiency: true,
  deficient: true,
  depressed: true,
  depression: true,
  destress: true,
  detox: true,
  detoxification: true,
  detoxify: true,
  DHT: true,
  diabetes: true,
  diagnose: true,
  diagnosing: true,
  disease: true,
  diseased: true,
  diuretic: true,
  divinorum: true,
  drug: true,
  dysfunction: true,
  "elephant climber": true,
  "elephant creeper": true,
  emotional: true,
  ephedra: true,
  erectile: true,
  erection: true,
  failure: true,
  "fast weight loss": true,
  "faster hair growth": true,
  fda: true,
  fertility: true,
  flu: true,
  food: true,
  free: true,
  "free ship": true,
  "free shipping": true,
  function: true,
  functionality: true,
  gluten: true,
  "gluten free": true,
  glycyrrhizic: true,
  glycyrrhizin: true,
  "growing hair": true,
  guarantee: true,
  hcg: true,
  hci: true,
  healing: true,
  "health linked to weight": true,
  healthier: true,
  healthiest: true,
  healthy: true,
  "healthy weight": true,
  "heart rate": true,
  "heavy metal": true,
  hemp: true,
  hormone: true,
  hormones: true,
  horny: true,
  hot: true,
  hunger: true,
  imbalance: true,
  immediate: true,
  immune: true,
  "immune defense": true,
  "immune response": true,
  immunity: true,
  impotency: true,
  infertility: true,
  inflammation: true,
  inflammatory: true,
  influenza: true,
  insomnia: true,
  instant: true,
  jimson: true,
  jimsonweed: true,
  "joint pain": true,
  "joints pain": true,
  klip: true,
  kratom: true,
  "large weight loss": true,
  laxative: true,
  LDL: true,
  legal: true,
  leonotis: true,
  lettsomia: true,
  levels: true,
  liane: true,
  lice: true,
  "life nutrition": true,
  lining: true,
  lion: true,
  "lions ear": true,
  lower: true,
  lowering: true,
  lozenges: true,
  "lymph nodes": true,
  maintain: true,
  manage: true,
  managed: true,
  management: true,
  maxman: true,
  "may help": true,
  md: true,
  "meal replacment": true,
  medicinal: true,
  medicine: true,
  melatonin: true,
  mental: true,
  mescaline: true,
  metabolism: true,
  metal: true,
  methoxetamine: true,
  microbes: true,
  "milk shake": true,
  mind: true,
  money: true,
  monoxide: true,
  mood: true,
  "morning glory": true,
  mucus: true,
  muscaria: true,
  mxe: true,
  nac: true,
  nacetyl: true,
  nepetifolia: true,
  nervosa: true,
  nightshade: true,
  "nighttime sleep aid": true,
  obesity: true,
  organic: true,
  pain: true,
  "pain relief": true,
  panic: true,
  pastora: true,
  pathogen: true,
  pathogens: true,
  peyote: true,
  pharmaceutical: true,
  plaque: true,
  pms: true,
  potency: true,
  pressure: true,
  prevented: true,
  "preventing hair loss": true,
  prevention: true,
  professional: true,
  promote: true,
  promotes: true,
  "promotes immune health": true,
  "positive mood": true,
  protozoa: true,
  pure: true,
  "pure caffeine": true,
  purify: true,
  "quality assurance": true,
  quinine: true,
  raise: true,
  "rapid weight loss": true,
  rate: true,
  reach: true,
  reduce: true,
  reducer: true,
  "regrowing hair": true,
  relief: true,
  relive: true,
  remedies: true,
  remedy: true,
  remover: true,
  repair: true,
  "repair damage": true,
  "resin ": true,
  restore: true,
  restoring: true,
  reumatoide: true,
  rhino: true,
  sale: true,
  salvia: true,
  satisfaction: true,
  seller: true,
  serotonin: true,
  "sex drive": true,
  shark: true,
  sleep: true,
  "sleep aid": true,
  "sleeping pill": true,
  "sleeping pills": true,
  sleepless: true,
  sleeplessness: true,
  snack: true,
  stress: true,
  steroids: true,
  stramonium: true,
  strengthen: true,
  sublingual: true,
  "sugar free": true,
  "sugar metabolism": true,
  superfood: true,
  suppress: true,
  suppressant: true,
  symptom: true,
  symptoms: true,
  tank: true,
  test: true,
  tested: true,
  thc: true,
  therapeutic: true,
  therapies: true,
  therapy: true,
  tract: true,
  treat: true,
  treated: true,
  treatment: true,
  ultimate: true,
  unclog: true,
  uti: true,
  Vidhara: true,
  "vitamin c": true,
  Vriddadaru: true,
  Vridhadaru: true,
  weed: true,
  "weight control": true,
  "white blood cells": true,
  "wood rose": true,
  woodrose: true,
  yeast: true,
};

export const fillerWords = {
  a: true,
  also: true,
  an: true,
  and: true,
  any: true,
  are: true,
  as: true,
  at: true,
  be: true,
  because: true,
  been: true,
  but: true,
  by: true,
  for: true,
  from: true,
  in: true,
  into: true,
  is: true,
  of: true,
  on: true,
  or: true,
  so: true,
  some: true,
  such: true,
  the: true,
  was: true,
  were: true,
  with: true,
};
